/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { TenantPayer } from '../models';
// @ts-ignore
import type { TenantPayerMapping } from '../models';
/**
 * TenantPayerApi - axios parameter creator
 * @export
 */
export const TenantPayerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get tenantpayer data
         * @summary Get tenantpayer data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantPayers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tenantpayer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<TenantPayerMapping>} tenantPayerMapping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapTenantPayers: async (tenantPayerMapping: Array<TenantPayerMapping>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantPayerMapping' is not null or undefined
            assertParamExists('mapTenantPayers', 'tenantPayerMapping', tenantPayerMapping)
            const localVarPath = `/api/v1/tenantpayer/map`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantPayerMapping, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantPayerApi - functional programming interface
 * @export
 */
export const TenantPayerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantPayerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get tenantpayer data
         * @summary Get tenantpayer data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenantPayers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantPayer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTenantPayers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantPayerApi.getTenantPayers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<TenantPayerMapping>} tenantPayerMapping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mapTenantPayers(tenantPayerMapping: Array<TenantPayerMapping>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mapTenantPayers(tenantPayerMapping, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantPayerApi.mapTenantPayers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TenantPayerApi - factory interface
 * @export
 */
export const TenantPayerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantPayerApiFp(configuration)
    return {
        /**
         * Get tenantpayer data
         * @summary Get tenantpayer data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantPayers(options?: RawAxiosRequestConfig): AxiosPromise<Array<TenantPayer>> {
            return localVarFp.getTenantPayers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantPayerApiMapTenantPayersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapTenantPayers(requestParameters: TenantPayerApiMapTenantPayersRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.mapTenantPayers(requestParameters.tenantPayerMapping, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantPayerApi - interface
 * @export
 * @interface TenantPayerApi
 */
export interface TenantPayerApiInterface {
    /**
     * Get tenantpayer data
     * @summary Get tenantpayer data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantPayerApiInterface
     */
    getTenantPayers(options?: RawAxiosRequestConfig): AxiosPromise<Array<TenantPayer>>;

    /**
     * 
     * @param {TenantPayerApiMapTenantPayersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantPayerApiInterface
     */
    mapTenantPayers(requestParameters: TenantPayerApiMapTenantPayersRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for mapTenantPayers operation in TenantPayerApi.
 * @export
 * @interface TenantPayerApiMapTenantPayersRequest
 */
export interface TenantPayerApiMapTenantPayersRequest {
    /**
     * 
     * @type {Array<TenantPayerMapping>}
     * @memberof TenantPayerApiMapTenantPayers
     */
    readonly tenantPayerMapping: Array<TenantPayerMapping>
}

/**
 * TenantPayerApi - object-oriented interface
 * @export
 * @class TenantPayerApi
 * @extends {BaseAPI}
 */
export class TenantPayerApi extends BaseAPI implements TenantPayerApiInterface {
    /**
     * Get tenantpayer data
     * @summary Get tenantpayer data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantPayerApi
     */
    public getTenantPayers(options?: RawAxiosRequestConfig) {
        return TenantPayerApiFp(this.configuration).getTenantPayers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantPayerApiMapTenantPayersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantPayerApi
     */
    public mapTenantPayers(requestParameters: TenantPayerApiMapTenantPayersRequest, options?: RawAxiosRequestConfig) {
        return TenantPayerApiFp(this.configuration).mapTenantPayers(requestParameters.tenantPayerMapping, options).then((request) => request(this.axios, this.basePath));
    }
}

